import { onSharingLinkDetected } from '../actions/internalActions';
import { addComposeLinkViewState } from 'owa-compose-link';
import { addSharingLink } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { orchestrator } from 'satcheljs';
import { lazyPrefetchWacResourcesForFiles } from 'owa-wac-prefetch-resources';

orchestrator(onSharingLinkDetected, actionMessage => {
    addSharingLink(
        actionMessage.linkId,
        actionMessage.linkUrl,
        actionMessage.sharingLinkIds,
        actionMessage.response,
        actionMessage.source,
        actionMessage.providerType
    );

    if (
        (actionMessage.response &&
            actionMessage.response.ResultCode === AttachmentResultCode.Success) ||
        actionMessage.isPreviouslyBeautified
    ) {
        if (actionMessage.shouldAddComposeLinkViewState) {
            addComposeLinkViewState(actionMessage.linkId);
        }
    }
});

orchestrator(onSharingLinkDetected, actionMessage => {
    if (
        actionMessage.response &&
        actionMessage.response.FileName &&
        actionMessage.providerType === AttachmentDataProviderType.OneDrivePro
    ) {
        lazyPrefetchWacResourcesForFiles.importAndExecute([actionMessage.response.FileName]);
    }
});
